import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

import { SharedService } from "@shared/services/shared.service";
import { IBusiness, INotesViewModel } from "app/models/business/business";
import { BusinessService } from "app/services/business/business.service";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { AddCitationsComponent } from "./addCitations/addCitations.component";
import { IBusinessCitationView } from "app/models/mainMenu/mainMenu";
import { AuthService } from "@shared/auth/auth.service";
import { Subscription } from "rxjs";


@Component({
  selector: 'shared-sharedCitations',
  styleUrls: ['./sharedCitations.component.scss'],
  templateUrl: './sharedCitations.component.html'
})

export class SharedCitationsComponent implements OnInit {
  
    // Called from either the Complaint(0) or Business(1) components
    @Input() parentPanel: number = 0;
  
    sharedSubscription: Subscription;
    currentBusiness: IBusiness = {} as IBusiness;
    citationsList: IBusinessCitationView[] = [];
    complaintCount: number = 0;
    commentCount: number = 0;
    currentTab: number = 0;
    editBusinessFlag: boolean = false;
    businessName: string = '';
    businessId: number = 0;
    isAdmin: boolean = false;
    complaintId: number = 0;

    panelParent: string = '';
  
    displayedColumns: string[] = ['id', 'complaintId', 'citationWarranted', 'finalOrderIssued', 
        'settlementAgreement', 'action'];
    dataSource = new MatTableDataSource<IBusinessCitationView>(this.citationsList);
  
    @ViewChild('TablePaginator') paginator: MatPaginator;
    @ViewChild('TableSort') sort: MatSort;
  
    constructor(
      private sharedService: SharedService,
      private businessService: BusinessService,
      private complaintService: ComplaintService,
      private authService: AuthService,
      private modalService: MatDialog
    ) {
  
    }
  
    ngOnInit(): void {
      if (this.parentPanel == 0) {
        this.sharedSubscription = this.complaintService.updateEvent.subscribe((data: number) => {
          if (data == 6) {
            this.businessId = this.complaintService.currentComplaint.businessId;
            this.getCitations();
            this.complaintId = this.complaintService.currentComplaint.complaintId;
          }
        });
      } else {
        this.sharedSubscription = this.businessService.updateBusinessEvent.subscribe((data: number) => {
          if (data == 5) {
            this.businessId = this.businessService.businessId;
            this.getCitations();
          }
        });
      }

      this.isAdmin = this.authService.isAdmin;
      this.panelParent = this.parentPanel == 0 ? 'complaint' : 'business';
    }

    ngOnDestroy() {
      this.sharedSubscription.unsubscribe();
    }
        
    getCitations() {
      this.complaintService.getCitations(this.businessId).subscribe({
        next: response => {
          this.citationsList = response;
          this.dataSource.data = this.citationsList;
        },
        error: e => {
          this.sharedService.toastr.error("Could not get Citation Info");
        },
      });
    }

    add(){
      this.editCitation(null);
    }

    editCitation(citation: IBusinessCitationView) {
      let config = new MatDialogConfig<any>();
      config.autoFocus = true;
      config.disableClose = false;
      config.minWidth = 600;
      config.maxWidth = 600;
      config.maxHeight = 800;
      config.data = { 
        modalCitation: citation,
        businessId: this.businessId,
        complaintId: this.complaintId
      };
      const dialogRef = this.modalService.open(AddCitationsComponent, config);
      dialogRef.afterClosed().subscribe(
        data => {
          if (data == 'saved') {
            this.getCitations();
          }
        },
        error => this.sharedService.toastr.error("Could not add business comments: " + error.message),
        () => { }
      );
    }
  
    gotoComplaint(complaintId: string){
      this.complaintService.complaintId = +complaintId;
      this.complaintService.complaintTab = 0;
      this.sharedService.doRedirect('complaint/complaint/'+complaintId);
      }

    editComplaint(complaintId: string){
      this.complaintService.complaintId = +complaintId;
      this.complaintService.complaintTab = 0;
      this.sharedService.doRedirect('complaint/complaint/'+complaintId);
    }

  }